import { IconProps } from "./";
import Icon from "./assets/pen_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Pen(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
